import { SkeletonLine, SkeletonImage } from "./SkeletonElements";

const DetailsSkeleton = () => {
    return (
        <div className="bg-base-100 rounded-xl shadow-sm border border-base-300 p-8 w-full h-full flex items-center justify-center">
            <div className="text-center">
                <SkeletonLine height="h-5" width="w-32" className="mx-auto mb-4" />
                <SkeletonImage className="mx-auto" />
            </div>
        </div>
    );
};

export default DetailsSkeleton;
